import { StyleSheet } from 'react-native';

export const expandableDescriptionStyles = StyleSheet.create({
  wrapper: {
    alignSelf: 'stretch',
  },
  text: {
    fontSize: 17,
    lineHeight: 26,
    color: 'inherit',
  },
  preLine: {
    whiteSpace: 'pre-line',
  },
  moreText: {
    cursor: 'pointer',
    color: 'inherit',
  },
});
